module.exports = __webpack_public_path__ + "static/media/033-computer.575c201b.svg";